import { render, staticRenderFns } from "./ClassroomEditor.vue?vue&type=template&id=5b7859ab&scoped=true&"
import script from "./ClassroomEditor.vue?vue&type=script&lang=ts&"
export * from "./ClassroomEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomEditor.vue?vue&type=style&index=0&id=5b7859ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7859ab",
  null
  
)

export default component.exports